/*!
 *  @preserve
 *  
 *  @module      iframe-resizer/legacy 5.3.2 (esm) - 2024-10-22
 *
 *  @license     GPL-3.0 for non-commercial use only.
 *               For commercial use, you must purchase a license from
 *               https://iframe-resizer.com/pricing
 * 
 *  @description Keep same and cross domain iFrames sized to their content 
 *
 *  @author      David J. Bradshaw <info@iframe-resizer.com>
 * 
 *  @see         {@link https://iframe-resizer.com}
 * 
 *  @copyright  (c) 2013 - 2024, David J. Bradshaw. All rights reserved.
 */


import '@iframe-resizer/jquery';
import contentWindow from '@iframe-resizer/child';
import iframeResize from '@iframe-resizer/parent';

const msg = `IFRAME-RESIZER 5

This package has been split into separate packages for Parent and Child pages. Along with new packages for jQuery, React and Vue.

Going forward you are advised to use the new separate packages for Parent and Child pages, rather than this combined package.

Please see https://iframe-resizer.com/upgrade for more details.
`;

console.info(msg);

const index_esm = {
  iframeResize,
  iframeResizer: iframeResize, // Backwards compatibility
  contentWindow,
};

export { index_esm as default };
